document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initGaleriaProducto();
  initVariantes();
  initMarquesinaHover();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-i', i % 8);
    observer.observe(el);
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var dur = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = target < 10 ? (target * eased).toFixed(1) : Math.round(target * eased);
        el.textContent = val + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var variantesJson = form.querySelector('[data-mt-variantes-json]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioComparadoEl = document.querySelector('[data-mt-precio-comparado]');
  var botonAgregar = document.querySelector('[data-mt-agregar]');
  if (!variantesJson || !idInput) return;
  var variantes;
  try { variantes = JSON.parse(variantesJson.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  if (!selects.length) return;

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatearMoneda(variante.price);
    if (precioComparadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioComparadoEl.textContent = formatearMoneda(variante.compare_at_price);
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (botonAgregar) {
      botonAgregar.disabled = !variante.available;
      botonAgregar.textContent = variante.available
        ? botonAgregar.getAttribute('data-texto-disponible')
        : botonAgregar.getAttribute('data-texto-agotado');
    }
  }

  function formatearMoneda(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function initMarquesinaHover() {
  var tracks = document.querySelectorAll('.mt-marquee-track');
  tracks.forEach(function (track) {
    track.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    track.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  });
}
